import { z } from "zod";

import { constantsData } from "@/data";
import { AccountHierarchyEnum } from "@/enums";

export const accountFormSchema = z.object({
    account: z.string().optional(),
    balanceType: z.string(),
    category: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    currency: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    description: z.string().optional(),
    hierarchy: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    id: z.string().optional(),
    name: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    number: z.string().optional(),
    startingBalance: z.string().optional(),
    startingBalanceDate: z.date().optional(),
    status: z["boolean"](),
}).refine(
    (data) => {
        if (data.hierarchy === AccountHierarchyEnum.SUB) return typeof data.account === "string" && data.account.trim().length > 0;

        return true;
    },
    {
        message: constantsData.msgs.requiredParentAccount,
        path: ["account"],
    },
).refine(
    (data) => !data.startingBalance?.trim() || data.startingBalanceDate instanceof Date,
    {
        message: constantsData.msgs.requiredField,
        path: ["startingBalanceDate"],
    },
);
